import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ValidationService } from '../service/validation.service';
import { formatNgbDate, processDataForCsvDoc } from '../utils/helpers';

import { CsvObject } from '../model/validation';
import { DcDownloadCsvComponent } from '@o3/ui-kit';
import { FormControl } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('csvDownloadComponent')
  csvDownloadComponent: DcDownloadCsvComponent;

  private subscriptions = new Subscription();
  loading;
  pass;
  fail;
  allValidationResults: CsvObject[];
  neededFieldsForCSV = [
    'id',
    'ruleId',
    'mnemonic',
    'description',
    'jmespath',
    'calculation',
    'pass',
  ];
  disableCsvBtn = false;
  searchControl = new FormControl('');
  dateRange;
  searchText;
  constructor(private validationService: ValidationService) {}

  ngOnInit(): void {
    this.getStatusTotals();
    this.listenForCsvDataUpdates();
    this.subscriptions.add(
      this.searchControl.valueChanges
        .pipe(distinctUntilChanged())
        .subscribe((change) => {
          this.searchText = change;
          let payload = {
            dateRange: this.dateRange,
            searchText: this.searchText,
          };
          this.validationService.setFilterValueSubject(payload);
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getStatusTotals() {
    this.subscriptions.add(
      this.validationService.statusTotalsObservable$.subscribe(
        (statuses) => {
          this.pass = statuses.pass;
          this.fail = statuses.fail;
        },
        (error) => {
          console.log(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      )
    );
  }

  downloadCsvRequest(value: boolean): void {
    if (value === true && !this.disableCsvBtn) {
      this.disableCsvBtn = true;
      this.validationService.setDownloadCsvSubject('downloadCsvRequest');
    }
  }

  listenForCsvDataUpdates(): void {
    this.subscriptions.add(
      this.validationService.csvDownloadObservable$.subscribe((data) => {
        if (typeof data !== 'string' && data.length > 0) {
          this.csvDownloadComponent.downloadCSV(data);
          this.disableCsvBtn = false;
        }
      })
    );
  }

  dateRangeFunc(event) {
    // console.log(event)
    if (event?.from) {
      event.from = formatNgbDate(event.from);
      if (event?.to) {
        event.to = formatNgbDate(event.to);
      }
    }
    this.dateRange = event;
    let payload = {
      dateRange: this.dateRange,
      searchText: this.searchText,
    };
    this.validationService.setFilterValueSubject(payload);
  }

  clearSearchInput(event): void {
    this.searchControl.setValue('');
  }
}
